<!--<mat-form-field class="demo-full-width" [formGroup]="group">-->
<div [formGroup]="group" class="field" [ngClass]="{ hidden: field.hidden }">
    <label
        for="{{ field.name }}-{{ formId }}"
        id="label-{{ field.name }}-{{ formId }}"
        [class.active]="hasFocus || hasValue(field.name)"
        [class.hasvalue]="!hasFocus && hasValue(field.name)"
    >
        <span class="labelcontent"><span [outerHTML]="field.label"></span><span *ngIf="field.required" class="is-required">*</span></span>
        <input
            [formControlName]="field.name"
            id="{{ field.name }}-{{ formId }}"
            type="number"
            (focus)="hasFocus = true"
            (blur)="hasFocus = false"
            step="any"
        />
        <ng-container *ngIf="field.description">
            <span class="hint" [innerHTML]="field.description"></span>
        </ng-container>
    </label>
    <ng-container *ngIf="group.get(field.name).touched">
        <ng-container *ngFor="let error of group.get(field.name).errors | getIterableErrors">
            <span class="error-msg">{{ getErrorTranslation(error) }}</span>
        </ng-container>
    </ng-container>
    <ng-container *ngFor="let dependentField of field.dependentFieldFilters">
        <div class="row">
            <ng-container *ngIf="getVisibilityByDependentFieldFiltersAndSetValidators(dependentField, group.get(field.name))">
                <ng-container
                    daDynamicField
                    [control]="dependentField.dependentFormField"
                    [reactiveFormData]="group"
                    [formId]="formId"
                ></ng-container>
            </ng-container>
        </div>
    </ng-container>
</div>
